import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil} from 'rxjs';
import { ContentService } from '../../services/content.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { jwtDecode } from 'jwt-decode';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { NgFor, NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
interface FoodNode {
  name: string;
  children?: FoodNode[];
  navigate: string;
  expandable?: boolean;
  ignore?:boolean;
}

const TREE_DATA: FoodNode[] = [
  {
    name: 'Traveler details',
    navigate: '',
    expandable: false,
    children: [
      {
        name: 'Personal information',
        navigate: '/cam/traveler-details/personal-info' 
      },
      {
        name: 'Contact details',
        navigate: '/cam/traveler-details/contact-detail',
      },
      {
        name: 'Document Information',
        navigate: '/cam/traveler-details/document-info',
      },
      {
        name: 'Employment details',
        navigate: '/cam/traveler-details/employee-details',
      },
      { name: 'Saved cards', navigate: '/cam/traveler-details/saved-cards' },
      { name: 'Preferences', navigate: '/cam/traveler-details/preferences' },
      {
        name: 'Emergency contact details',
        navigate: '/cam/traveler-details/emergency-contact',
      },
      {
        name: 'Change passwords',
        navigate: '/cam/traveler-details/change-password',
      },
    ],
  },
  {
    name: 'Saved dependents',
    navigate: '',
    expandable: false,
    children: [
      { name: 'Dependents details', navigate: '/cam/saved-dependents/dependent-form' }
    ]
  },
  {
    name: 'Manager & delegation settings',
    navigate: '',
    expandable: false,
    children: [
      { name: 'Reporting manager & traveler arranger', navigate: '/cam/manage-delegation-setting/reporting-manager' },
      // { name: 'Approvers', navigate: '/cam/manage-delegation-setting/approvers' },
      { name: 'Delegation', navigate: '/cam/manage-delegation-setting/delegation' }
    ]
  },
  {
    name: 'Manage devices',
    navigate: '',
    expandable: false,
    children: [
      { name: 'Logged in devices', navigate: '/cam/manage-devices/loggedin-devices' }
    ]
  }
];

@Component({
    selector: 'app-menu-nav-traveler',
    templateUrl: './menu-nav-traveler.component.html',
    styleUrls: ['./menu-nav-traveler.component.scss'],
    imports: [NgFor, MatIconButton, MatIcon, NgIf, RouterLinkActive, RouterLink]
})
export class MenuNavTravelerComponent implements OnInit, OnDestroy {
  dataSource: FoodNode[];
  originalDataSource: FoodNode[] = [];
  userId: any;
  guid: any;
  disabledLink: boolean = false;
  content: any;
  companySettingDetails:any;
  isShowDeligation:boolean=true;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly router: Router,
    private readonly contentService: ContentService,
    private readonly _CamApiService: CamService,
    private readonly travelerManagementService: TravelerManagement
  ) {
    this.originalDataSource = JSON.parse(JSON.stringify(TREE_DATA));
    this.dataSource = JSON.parse(JSON.stringify(TREE_DATA));
    this.contentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = res;
        if (this.dataSource) {
          this.dynamicMenu();
        }
      });
    // this.dataSource = TREE_DATA;
    // this.dataSource.forEach(($: any, $index: number) => {
    //   $.expandable = $index == 0 ? true : false;
    // });
    let anyMatched = false;
    this.dataSource = TREE_DATA;
    const currentUrl = this.router.url;
    this.dataSource.forEach((node) => {
      const isActive = node.children?.some(
        (child) => child.navigate === currentUrl
      );
      node.expandable = !!isActive;

       if (isActive) {
        anyMatched = true;
      }

    });

    // Agar koi route match nahi hua → first open karo
      if (!anyMatched && this.dataSource.length > 0) {
        this.dataSource[0].expandable = true;
      }

  }

  ngOnInit(): void {
    const stored = localStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS) ?? sessionStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS);
    this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    this.isShowDeligation = this.companySettingDetails?.enableGoOnLeave;
    this._CamApiService.ciamTraveller$
      .pipe(takeUntil(this.destroy$))
      .subscribe((ciamid: string) => {
        const travellrciamID = ciamid?.trim() ?? '';
        
              const QlAccessToken = localStorage.getItem('QlAccessToken');
             const decoded: any = QlAccessToken ? jwtDecode(QlAccessToken) : null;
                const ciamID = decoded?.ciamId.trim();
        const loginUserCiamID = ciamID;
        const showChangepassword =
          (loginUserCiamID === travellrciamID) || travellrciamID == '';
          const travelerGUID = localStorage.getItem('travelerGUID')?.trim().toUpperCase();
        const userGUID = localStorage.getItem('userGuid')?.trim().toUpperCase();

        const isGuidMatch = !!(travelerGUID && userGUID && travelerGUID === userGUID);
        const isFederated = decoded?.IsFederatedAccount === 'True' || decoded?.isFederatedAccount === 'True';
        this.applyTravelerMenuFilters(isGuidMatch && !isFederated, this.isOwnLoggedInUser());
      });
      this.applyTravelerMenuFilters(true, this.isOwnLoggedInUser());
  }

  private isOwnLoggedInUser(): boolean {
    const selectedUserId = String(sessionStorage.getItem('userId') || '').trim();
    const QlAccessToken = localStorage.getItem('QlAccessToken');
    const decoded: any = QlAccessToken ? jwtDecode(QlAccessToken) : null;
    const loggedInUserId = String(decoded?.userId || '').trim();
    return !!selectedUserId && !!loggedInUserId && selectedUserId === loggedInUserId;
  }

  applyTravelerMenuFilters(showChangePassword: boolean, showManageDevices: boolean) {
    this.dataSource = JSON.parse(JSON.stringify(this.originalDataSource));

    if (!showChangePassword) {
      this.dataSource[0].children =
        this.dataSource[0].children?.filter(
          x => x.navigate !== '/cam/traveler-details/change-password'
        );
    }

    if (!showManageDevices) {
      this.dataSource = this.dataSource.filter(nav => nav.name !== 'Manage devices');
    }

    if (!this.isShowDeligation) {
      this.dataSource = this.dataSource.map(nav => {
        if (nav.name === 'Manager & delegation settings') {
          return {
            ...nav,
            children: nav.children?.filter(child => child.name !== 'Delegation')
          };
        }
        return nav;
      });
    }

    if (this.content) {
      this.dynamicMenu();
    }

    const currentUrl = this.router.url;
    let anyMatched = false;
    this.dataSource.forEach((node) => {
      const isActive = node.children?.some((child) => child.navigate === currentUrl);
      node.expandable = !!isActive;
      if (isActive) {
        anyMatched = true;
      }
    });
    if (!anyMatched && this.dataSource.length > 0) {
      this.dataSource[0].expandable = true;
    }
  }

  toggleChangePassword(show: boolean) {
    this.applyTravelerMenuFilters(show, this.isOwnLoggedInUser());
  }

  onChildClick(event: Event) {
    event.stopPropagation();
     // Child menu GTM
    this.travelerManagementService.traveler_menu_click();
  }

  dynamicMenu() {
    this.dataSource[0]?.children?.forEach((value, index) => {
      switch (index) {
        case 0:
          value.name = this.content?.['b2b.managetraveler.personalinfo'];
          break;
        case 1:
          value.name = this.content?.['b2b.managetraveler.contactdetails'];
          break;
        case 2:
          value.name = this.content?.['b2b.managetraveler.docinfo'];
          break;
        case 3:
          value.name = this.content?.['b2b.managetraveler.employmentdetails'];
          break;
        case 4:
          value.name = this.content?.['b2b.managetraveler.savedcards'];
          break;
        case 5:
          value.name = this.content?.['b2b.managetraveler.preferences'];
          break;
        case 6:
          value.name = this.content?.['b2b.managetraveler.emercontactdetails'];
          break;
        case 7:
          value.name = this.content?.['b2b.managetraveler.changepassword'];
          break;
      }
    });
    if (this.dataSource[1]?.children?.[0]) {
      this.dataSource[1].children[0].name =
        this.content?.['b2b.managetraveler.dependentdetails'];
    }
  }
  // travelerManagement(index: number) {
  //   this.dataSource.forEach((node, i) => {
  //     node.expandable = i === index ? !node.expandable : false;
  //   });
  // }

  onTravelerMenuClick(clickedNode: any) {

  // this.travelerManagementService.traveler_menu_click();

  this.dataSource.forEach(node => {
    if (node === clickedNode) {
      node.expandable = !node.expandable;
    } else {
      node.expandable = false;
    }
  });

}

onMenuClick(clickedNode: any, event?: Event) {

  if (event) {
    event.stopPropagation();
  }

  // GTM Call
  this.travelerManagementService.traveler_menu_click();

  // Parent accordion only
  this.dataSource.forEach(node => {

    if (node === clickedNode) {
      node.expandable = !node.expandable;
    } else {
      node.expandable = false;
    }

  });

}

  // travelerManagement(clickedNode: any) {
  //   this.travelerManagementService.traveler_menu_click();
  //   this.dataSource.forEach(node => {
  //     if (node === clickedNode) {
  //       node.expandable = !node.expandable;
  //     } else {
  //       node.expandable = false;
  //     }
  //   });

  // }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}